module.exports = __webpack_public_path__ + "static/media/renewal_banner_phase1.946ba256.png";